<template>
  <Fragment>
    <el-form-item label="品牌" prop="brandId">
      <el-select v-model="selectBrand" @change="brandChange" clearable filterable placeholder="请选择品牌">
        <el-option v-for="item in brandList" :label="item.brand" :value="item.id" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="车系" prop="seriesId">
      <el-select v-model="selectSeries" @change="seriesChange" clearable filterable placeholder="请选择车系" :disabled="seriesDisable">
        <el-option v-for="item in seriesList" :label="item.series" :value="item.seriesId"
          :key="item.seriesId"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-if="showModel" label="车型" prop="carModelId">
      <el-select v-model="selectModel" @change="modelChange" clearable filterable placeholder="请选择车型" :disabled="modelDisable">
        <el-option v-for="(item, index) in modelList" :label="item.modelName" :value="item.modelId"
          :key="index"></el-option>
      </el-select>
    </el-form-item>
  </Fragment>
</template>
<script>
import { getAllCarModelList } from '@/api/carManage'
import { carBrandList, carSeriesList } from '@/api/domain/organize'

export default {
  name: 'CarBrandSeriesModel',
  props: ['brandId', 'seriesId', 'modelId', 'showModel', 'brandSeriesModel'],
  model: {
    prop: 'brandSeriesModel',
    event: 'change',
  },
  data() {
    return {
      selectBrand: this.brandId,
      selectSeries: this.seriesId,
      selectModel: this.modelId,
      modelList: [], // 车型列表
      brandList: [], // 品牌列表
      seriesList: [], // 车系列表
    }
  },
  watch: {
    // 品牌改变
    brandId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectBrand = newVal
      }
      this.handleBrandIdClear()
    },
    // 车系改变
    seriesId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectSeries = newVal
      }
      this.handleSeriesIdClear()
    },
    // 车型改变
    modelId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectModel = newVal
      }
    },
    brandSeriesModel: {
      handler(newVal, oldVal) {
        const { brandId, seriesId, modelId } = newVal || {}
        const { brandId: oldBrandId, seriesId: oldSeriesId, modelId: oldModelId } = oldVal || {}
        if (brandId !== oldBrandId) {
          this.selectBrand = Number(brandId) || null
          this.handleBrandIdClear()
          if (brandId) {
            this.getSeriesList(brandId)
          }
        }
        if (seriesId !== oldSeriesId) {
          this.selectSeries = Number(seriesId) || null
          this.handleSeriesIdClear()
          if (seriesId) {
            this.getCarModelList()
          }
        }
        if (modelId !== oldModelId) {
          this.selectModel = Number(modelId) || null
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // 车系禁用标识
    seriesDisable() {
      return !this.selectBrand
    },
    // 车车型禁用标识
    modelDisable() {
      return !this.selectSeries
    },
  },
  methods: {
    // 获取品牌列表
    getBrandList() {
      carBrandList().then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.brandList = data
        }
      })
    },
    // 获取车系列表
    getSeriesList(val) {
      carSeriesList({
        brandId: val,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.seriesList = data
        }
      })
    },
    // 获取车型列表
    getCarModelList() {
      getAllCarModelList({
        brandId: this.selectBrand,
        seriesId: this.selectSeries,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.modelList = data
        }
      })
    },
    // 清空品牌
    handleBrandIdClear() {
      this.seriesList = []
      this.modelList = []
      this.selectSeries = null
      this.selectModel = null
    },
    // 清空车系
    handleSeriesIdClear() {
      this.modelList = []
      this.selectModel = null
    },
    // 重置 父级有用
    // eslint-disable-next-line vue/no-unused-properties
    reset() {
      this.selectBrand = null
      this.selectSeries = null
      this.selectModel = null
    },
    brandChange(newVal) {
      this.$emit('update:brandId', newVal)
      this.$emit('change', { brandId: newVal })
      if (newVal) {
        this.getSeriesList(newVal)
      }
      this.handleBrandIdClear()
    },
    seriesChange(newVal) {
      this.$emit('update:seriesId', newVal)
      const { selectBrand: brandId } = this
      this.$emit('change', {
        brandId,
        seriesId: newVal,
      })
      if (this.showModel) {
        if (newVal) {
          this.getCarModelList(newVal)
        }
        this.handleSeriesIdClear()
      }
    },
    modelChange(newVal) {
      const { selectBrand: brandId, selectSeries: seriesId } = this
      this.$emit('change', {
        brandId,
        seriesId,
        modelId: newVal,
      })
      this.$emit('update:modelId', newVal)
    },
  },
  created() {
    this.getBrandList()
  },
}
</script>
